import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { LazyAlertIssueSync } from './async.tsx';

export const AlertIssueSync = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAlertIssueSync}
		pageId="async-jira-eoc-alert-issue-syncing"
		shouldShowSpinner
	/>
);
